import React, { FC, useState, useEffect, useCallback } from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import { WalletStyles } from '../styles';
import { listUnspent } from '../../../webservice/mProviders';
import { homenetwork, homepvtKey } from '../../../Headerr';
import { bsv } from '../../../scrypt-ts-this/distthis/index';

const WalletDashboard: FC = () => {
  const [balance, setBalance] = useState<number>(0);
  const [address, setAddress] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const fetchBalance = useCallback(async () => {
    if (homepvtKey.length !== 64) return;
    setLoading(true);
    try {
      const privateKey = bsv.PrivateKey.fromHex(homepvtKey, homenetwork);
      const addr = bsv.Address.fromPrivateKey(privateKey).toString();
      setAddress(addr);
      const UTXOs = await listUnspent(addr, homenetwork);
      let total = 0;
      for (let i = 0; i < UTXOs.length; i++) {
        total += UTXOs[i].satoshis;
      }
      setBalance(total);
    } catch (e) {
      console.error('Failed to fetch balance:', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBalance();
  }, [fetchBalance]);

  const formatBSV = (sats: number) => {
    return (sats / 100000000).toFixed(8);
  };

  return (
    <Box>
      <Box sx={WalletStyles.balanceCard}>
        <Typography sx={WalletStyles.balanceLabel}>Saldo Total</Typography>
        {loading ? (
          <CircularProgress size={32} sx={{ color: '#7BA238', my: 2 }} />
        ) : (
          <>
            <Typography sx={WalletStyles.balanceAmount}>
              {formatBSV(balance)} BSV
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(123, 162, 56, 0.6)', mt: 1 }}>
              {balance.toLocaleString()} satoshis
            </Typography>
          </>
        )}
        {address && (
          <Typography variant="body2" sx={{ color: 'rgba(123, 162, 56, 0.5)', mt: 2, fontSize: '0.75rem', wordBreak: 'break-all' }}>
            {address}
          </Typography>
        )}
      </Box>

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 3, flexWrap: 'wrap' }}>
        <Button variant="contained" sx={WalletStyles.actionButton} onClick={fetchBalance}>
          🔄 Atualizar Saldo
        </Button>
      </Box>

      <Box sx={{ ...WalletStyles.card, mt: 3 }}>
        <Typography sx={WalletStyles.sectionTitle}>Tokens 1sat</Typography>
        <Typography sx={WalletStyles.noDataText}>
          Nenhum token 1sat encontrado para este endereço.
        </Typography>
      </Box>
    </Box>
  );
};

export default WalletDashboard;
